import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppDimmer } from "../../Generic/AppDimmer";
import { AppOverlay } from "../../Generic/AppOverlay";
import { If } from "../../Generic/If";
import SearchModalInput from "../SearchModalInput/SearchModalInput";
import SearchModalCardError from "./SearchModalCardError";

interface Props {
  placeholder?: string;
  value?: string;
  hasError: boolean;
  isOpen: boolean;
  onChange: (newValue: string) => void;
  onRequestClose: () => void;
}

const SearchModalCard = ({
  placeholder,
  value,
  hasError,
  isOpen,
  children,
  onChange,
  onRequestClose,
}: PropsWithChildren<Props>) => {
  return (
    <AppOverlay
      className={classNames({
        SearchModalOverlay: true,
        Active: isOpen,
      })}
    >
      <AppCard className="SearchModalCard">
        <AppCardContent className="__searchModalInput">
          <SearchModalInput
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onClose={onRequestClose}
          />
        </AppCardContent>

        <If condition={hasError}>
          <AppCardContent>
            <SearchModalCardError />
          </AppCardContent>
        </If>

        <div className="__children">{children}</div>
      </AppCard>
      <AppDimmer />
    </AppOverlay>
  );
};

export default React.memo(SearchModalCard);
